import React from 'react';
import { useLocationContent } from '@/hooks/useLocationContent';
import EnhancedLocationContent from './EnhancedLocationContent';
import LocationFAQ from './LocationFAQ';
import { Card, CardContent } from '@/components/ui/card';

interface LocationContentLoaderProps {
  cityName: string;
  countyName: string;
  population: number;
  longitude: number;
}

const LocationContentLoader: React.FC<LocationContentLoaderProps> = ({ 
  cityName, 
  countyName, 
  population, 
  longitude 
}) => {
  const { content, loading, error } = useLocationContent(cityName);

  if (loading) {
    return (
      <div className="space-y-4">
        {[...Array(6)].map((_, i) => (
          <Card key={i} className="animate-pulse">
            <CardContent className="p-6">
              <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
              <div className="space-y-2">
                <div className="h-3 bg-gray-200 rounded"></div>
                <div className="h-3 bg-gray-200 rounded"></div>
                <div className="h-3 bg-gray-200 rounded w-5/6"></div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <Card className="border-red-200">
        <CardContent className="p-6 text-center">
          <p className="text-red-600">Unable to load location-specific content. Please try again later.</p>
        </CardContent>
      </Card>
    );
  }

  if (!content) {
    return null;
  }

  const isCoastal = longitude > -77.5; // Coastal zone detection

  return (
    <div className="space-y-8">
      <EnhancedLocationContent
        {...content}
        cityName={cityName}
      />
      <LocationFAQ 
        cityName={cityName}
        countyName={countyName}
        population={population}
        isCoastal={isCoastal}
      />
    </div>
  );
};

export default LocationContentLoader;